import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

const INITIAL_INDEX = 0;

@Component({
  selector: 'app-product-image-gallery',
  templateUrl: './product-image-gallery.component.html',
  styleUrls: ['./product-image-gallery.component.scss'],
  standalone: false
})
export class ProductImageGalleryComponent {
  appStrings: AppLocalization;
  images: string[];
  currentIndex: number;

  constructor(
    private appInfoService: AppInfoService,
    private dialogRef: MatDialogRef<ProductImageGalleryComponent>,
    @Inject(MAT_DIALOG_DATA) data: { images: string[] }
  ) {
    this.appStrings = this.appInfoService.appStrings;
    this.images = data?.images || [];
    this.currentIndex = INITIAL_INDEX;
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  }

  selectImage(index: number) {
    this.currentIndex = index;
  }

  close() {
    this.dialogRef.close();
  }
}
